import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 md:pt-40 pb-24 bg-cream min-h-screen" data-testid="blog-page">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <span className="font-sans uppercase tracking-[0.35em] text-[11px] text-amber-deep">The Journal</span>
        <h1 className="mt-5 font-serif text-5xl md:text-7xl leading-[0.9] text-obsidian max-w-3xl">
          Science, ritual<br /><span className="italic">& everything between.</span>
        </h1>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {posts.map((p, i) => (
            <Reveal
              as="article"
              key={p.slug}
              delay={(i % 3) * 0.08}
              className="group"
              data-testid={`blog-item-${p.slug}`}
            >
              <Link to={`/blog/${p.slug}`}>
                <div className="relative overflow-hidden aspect-[4/3] bg-sand">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <p className="mt-5 font-sans uppercase tracking-[0.2em] text-[10px] text-amber-deep">{p.category} · {p.read_time}</p>
                <h2 className="mt-2 font-serif text-3xl leading-tight text-obsidian group-hover:text-amber-deep transition-colors">{p.title}</h2>
                <p className="mt-2 font-sans font-light text-obsidian/60 leading-relaxed">{p.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
